import { useState } from "react";
import { useLockScroll } from "./auth-service-tools557.js";
import { useId } from "./auth-service-tools271.js";
import { useWindowEvent } from "./auth-service-tools558.js";
import { useFocusReturn } from "./auth-service-tools277.js";

function useModal(_ref) {
  let {
    id,
    transitionProps,
    opened,
    trapFocus,
    closeOnEscape,
    onClose,
    returnFocus
  } = _ref;

  const _id = useId(id);

  const [titleMounted, setTitleMounted] = useState(false);
  const [bodyMounted, setBodyMounted] = useState(false);
  const transitionDuration = typeof (transitionProps == null ? void 0 : transitionProps.duration) === "number" ? transitionProps == null ? void 0 : transitionProps.duration : 200;
  const shouldLockScroll = useLockScroll({
    opened,
    transitionDuration
  });
  useWindowEvent("keydown", event => {
    var _a;

    if (event.key === "Escape" && closeOnEscape && opened) {
      const shouldTrigger = ((_a = event.target) == null ? void 0 : _a.getAttribute("data-mantine-stop-propagation")) !== "true";
      shouldTrigger && onClose();
    }
  }, {
    capture: true
  });
  useFocusReturn({
    opened,
    shouldReturnFocus: trapFocus && returnFocus
  });
  return {
    _id,
    titleMounted,
    bodyMounted,
    shouldLockScroll,
    setTitleMounted,
    setBodyMounted
  };
}

export { useModal };